'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactRedux = require('react-redux');

var _DefaultString = require('../../helpers/DefaultString');

var _Product = require('../../helpers/Product');

var _LinkExpired = require('./LinkExpired.scss');

var _LinkExpired2 = _interopRequireDefault(_LinkExpired);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LinkExpired = (_dec = (0, _reactRedux.connect)(function (state) {
  return { auth: state.auth };
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(LinkExpired, _Component);

  function LinkExpired() {
    (0, _classCallCheck3.default)(this, LinkExpired);
    return (0, _possibleConstructorReturn3.default)(this, (LinkExpired.__proto__ || (0, _getPrototypeOf2.default)(LinkExpired)).apply(this, arguments));
  }

  (0, _createClass3.default)(LinkExpired, [{
    key: 'render',
    value: function render() {
      var formatMessage = this.props.intl.formatMessage;


      return _react2.default.createElement(
        'div',
        { className: _LinkExpired2.default.linkExpired },
        _react2.default.createElement(
          'div',
          { className: _LinkExpired2.default.title },
          _react2.default.createElement(_reactIntl.FormattedMessage, (0, _extends3.default)({}, _DefaultString.translations.UniversalLoginTitle, {
            values: { product: formatMessage((0, _Product.getProductName)(this.props.auth.realm, this.props.auth.productName, this.props.auth.clientId)) }
          }))
        ),
        _react2.default.createElement(
          'div',
          { className: _LinkExpired2.default.message },
          _react2.default.createElement(_reactIntl.FormattedHTMLMessage, _DefaultString.translations.LinkExpiredText)
        )
      );
    }
  }]);
  return LinkExpired;
}(_react.Component), _class2.propTypes = {
  auth: _react.PropTypes.object,
  intl: _reactIntl.intlShape.isRequired
}, _temp)) || _class);
exports.default = (0, _reactIntl.injectIntl)(LinkExpired);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/LinkExpired/LinkExpired.js
// module id = 2009
// module chunks = 0